import React from 'react'
import SidebardFilter from './SidebardFilter'
import SidebardSearch from './SidebardSearch'
import SidebardCollections from './SidebardCollections'

const Fonctions = () => {
  return (
    <div>
        <SidebardFilter />
        <SidebardSearch />
        <SidebardCollections />
    </div>
  )
}

export default Fonctions